import React, { useEffect, useState } from 'react';
import { DatePicker, Form, InputNumber, Select } from 'antd';
import dayjs from 'dayjs';

import { Project } from '@totem/components/ticketing/ticketing';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  isEdit: boolean;
  project: Project;
  onChange: (project: Project) => void;
};

const ProjectTicketCreate = ({ project, onChange }: Props) => {
  const [projectData, setProjectData] = useState<Project>(
    isNotNull(project)
      ? project
      : {
          startDate: dayjs().toISOString(),
          endDate: dayjs().toISOString(),
          status: 'PENDING',
          fee: 0.0,
          billedAmount: 0.0,
          budgetedHours: 0.0,
          actualHours: 0.0,
          billingType: '',
          expensesType: '',
        },
  );

  const billingTypeOptions = [
    { value: '', label: <span>-- Select --</span> },
    { value: 'Non-Billable', label: <span>Non-Billable</span> },
    { value: 'Fixed Fee', label: <span>Fixed Fee</span> },
    { value: 'Time & Material', label: <span>Time &amp; Material</span> },
    { value: 'Milestone', label: <span>Milestone</span> },
    { value: 'Recurring', label: <span>Recurring</span> },
  ];

  const expensesTypeOptions = [
    { value: '', label: <span>-- Select --</span> },
    { value: 'Billable (Capped)', label: <span>Billable (Capped)</span> },
    { value: 'Billable', label: <span>Billable</span> },
    { value: 'Non-Billable', label: <span>Non-Billable</span> },
  ];

  useEffect(() => {
    onChange(projectData);
  }, [projectData]);

  return (
    <>
      <Form layout="vertical" component={false}>
        <Form.Item
          label="Start Date"
          name="startDate"
          initialValue={
            isNotNull(projectData) && projectData.startDate !== ''
              ? dayjs(projectData.startDate)
              : dayjs()
          }
          rules={[{ required: true, message: 'Please select date' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            value={
              isNotNull(projectData) && projectData.startDate !== ''
                ? dayjs(projectData.startDate)
                : dayjs()
            }
            onChange={(newValue) =>
              setProjectData((prevState) => ({
                ...prevState,
                startDate: newValue.toISOString(),
              }))
            }
          />
        </Form.Item>
        <Form.Item
          label="End Date"
          name="endDate"
          initialValue={
            isNotNull(projectData) && projectData.endDate !== ''
              ? dayjs(projectData.endDate)
              : dayjs()
          }
        >
          <DatePicker
            style={{ width: '100%' }}
            value={
              isNotNull(projectData) && projectData.endDate !== ''
                ? dayjs(projectData.endDate)
                : dayjs()
            }
            onChange={(newValue) =>
              setProjectData((prevState) => ({
                ...prevState,
                endDate: newValue.toISOString(),
              }))
            }
          />
        </Form.Item>

        <Form.Item
          label="Billing Type"
          name="billingType"
          initialValue={isNotNull(projectData) ? projectData.billingType : ''}
        >
          <Select
            options={billingTypeOptions}
            onChange={(newValue) =>
              setProjectData((prevState) => ({
                ...prevState,
                billingType: newValue,
              }))
            }
          />
        </Form.Item>
        <Form.Item
          label="Expenses Type"
          name="expensesType"
          initialValue={isNotNull(projectData) ? projectData.expensesType : ''}
        >
          <Select
            options={expensesTypeOptions}
            onChange={(newValue) =>
              setProjectData((prevState) => ({
                ...prevState,
                expensesType: newValue,
              }))
            }
          />
        </Form.Item>

        <Form.Item label="Fee" name="fee" initialValue={projectData.fee}>
          <InputNumber
            min={0}
            style={{ width: '100%' }}
            value={projectData.fee}
            onChange={(value) =>
              setProjectData((prevState) => ({
                ...prevState,
                fee: value,
              }))
            }
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default ProjectTicketCreate;
